<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información del Destino">
          <b-form>
            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-documento-tipo
              label="Tipo Identificación"
              :nombre="documentoTipoNombre"
              :lista="documentosTiposList"
              :valido="documentoTipoValido"
              :msjInvalido="documentoTipoInvalidoMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="documentoTipoActualizado">
            </app-documento-tipo>  

            <b-form-group
              label="Cod.Identificación"
              label-for="documentoNumero"
              :label-cols="labelCols"
              description="Código de identificación tributaria (CUIT, CIF, TIN\EIN, etc). En caso de CUIT, ingrese sólo dígitos numéricos."
              horizontal>
              <b-form-input 
                id="documentoNumero"
                v-model.trim="$v.documentoNumero.$model" 
                :state="documentoNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="documentoNumeroFeedback">
                {{ documentoNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Dirección"
              label-for="direccion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="direccion"
                v-model.trim="$v.direccion.$model" 
                :state="direccionValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="direccionFeedback">
                {{ direccionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-pais
              label="Pais"
              :nombre="paisNombre"
              :lista="paisesList"
              :valido="paisValido"
              :msjInvalido="paisInvalidoMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="paisActualizado">
            </app-pais>

            <app-provincia
              label="Provincia"
              :nombre="provinciaNombre"
              :lista="provinciasList"
              :valido="provinciaValida"
              :msjInvalido="provinciaInvalidaMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="provinciaActualizada">
            </app-provincia>  

            <app-localidad
              label="Localidad"
              :nombre="localidadNombre"
              :lista="localidadesList"
              :valido="localidadValida"
              :msjInvalido="localidadInvalidaMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="localidadActualizada">

              <div class="custom-select-add" 
                v-if="accesoLocalidadesABM"
                @click.prevent="addLocalidad">
                  <i class="fa fa-plus" aria-hidden="true"></i>
              </div>
            </app-localidad>  

            <b-form-group
              label="Cod.Postal"
              label-for="codigoPostal"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="codigoPostal"
                v-model.trim="$v.codigoPostal.$model" 
                :state="codigoPostalValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="codigoPostalFeedback">
                {{ codigoPostalInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Teléfono"
              label-for="telefono"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="telefono"
                v-model.trim="$v.telefono.$model" 
                :state="telefonoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="telefonoFeedback">
                {{ telefonoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label-for="inactivo"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>

          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>             

          <div slot="footer" v-if="modal">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="localidadModal"
        hide-header
        hide-footer
        lazy>
      <app-alta-localidad
        :provincia="provincia" 
        @updateLocalidades="updateLocalidades"
        @closeLocalidad="closeLocalidad">
      </app-alta-localidad>  
    </b-modal>

    <app-a-b-m-button
      v-if= "!modal"
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import DocumentoTipo from '../shared/abmSelect.vue';
import Pais from '../shared/abmSelect.vue';
import Provincia from '../shared/abmSelect.vue';
import Localidad from '../shared/abmSelect.vue';
import AltaLocalidad from '../localidades/modalABM.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, requiredIf, numeric, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'remitodestino/getField',
  mutationType: 'remitodestino/updateField',
});

const DocumentoValido = ((value, vm) => {
  if (value == '') {
    return true;
  } else {

    /* Sólo validamos el formato del CUIT */
    let isValid = true;
    switch (vm.documentoTipoId) {
      case 2:
        /* Cuit (11 digitos numéricos) */
        if (isNaN(parseInt(value))) {
          isValid = false;
        } else {
          let length = Math.log(value) * Math.LOG10E + 1 | 0;  
          if (length != 0 & length != 11) {
            isValid = false;
          }
        }
        break;
    }
    return isValid;
  }
})

export default {
  name: 'ABM',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    remitoDestinoId: {
      type: Number,
      default: 0
    }
  },
  components: {
    appABMButton: ABMButtons,
    appDocumentoTipo: DocumentoTipo,
    appPais: Pais,
    appProvincia: Provincia,
    appLocalidad: Localidad,
    appAltaLocalidad: AltaLocalidad,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',

      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',
      documentoTipoValido: null,
      documentoTipoInvalidoMsj: '',
      documentoNumeroValido: null,
      documentoNumeroInvalidoMsj: '',
      direccionValida: null,
      direccionInvalidaMsj: '',
      paisValido: null,
      paisInvalidoMsj: '',
      provinciaValida: null,
      provinciaInvalidaMsj: '',
      localidadValida: null,
      localidadInvalidaMsj: '',
      codigoPostalValido: null,
      codigoPostalInvalidoMsj: '',
      telefonoValido: null,
      telefonoInvalidoMsj: '',

      labelCols: 2,
      loadingPaises: false,
      loadingProvincias: false,
      accesoLocalidadesABM: false,
      documentosTipos: [],
      documentosTiposList: [],
      paises: [],
      paisesList: [],
      provincias: [],
      provinciasList: [],
      localidades: [],
      localidadesList: []
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      'documentoTipo',
      'documentoTipoNombre',
      'documentoNumero',
      'direccion',
      'pais',
      'paisNombre',
      'provincia',
      'provinciaNombre',
      'localidad',
      'localidadNombre',
      'codigoPostal',
      'telefono',
      'inactivo',
    ])
  },  
  created() {
    let remitoDestinoId = 0;

    if ((/true/i).test(this.modal)) {
      this.labelCols = 3;
      if (this.remitoDestinoId) {
        if (this.remitoDestinoId != 0) {
          remitoDestinoId = this.remitoDestinoId;
        }
      }
    } else {
      if (this.$route.params){
        if (this.$route.params.id){
          remitoDestinoId = this.$route.params.id;
        }
      }
    }

    this.loadingPaises = true;
    this.loadingProvincias = true;
    
    this.showSpinner();
    this.$store.dispatch('remitodestino/inicializar', remitoDestinoId)
      .then(() => this.getDatosAdicionales())
      .catch(error => {
        if (!this.modal) {
          this.showErrorMsj(error);
        } else {
          this.alertMsj = error;
          this.alertVariant = "danger";
          this.alertCountDown = 15;
          this.showAlert();              
        }
      })
      .finally(() => this.hideSpinner());
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      const vm = this;
      
      this.$store.dispatch('paises/getPaisesSelect')
        .then(() => {
          vm.paises = this.$store.getters['paises/paisesSelect'];
          vm.paisesList = this.$store.getters['paises/listSelect'];
          vm.loadingPaises = false;
          return;
        })
        .then (() => this.getProvincias())
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de paises.'));

      this.$store.dispatch('documentostipos/getList')
        .then(() => {
          vm.documentosTipos = this.$store.getters['documentostipos/list'];
          vm.documentosTiposList = this.$store.getters['documentostipos/selectList'];
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de tipos de documento'));
    },
    getProvincias() {
      this.provincias = [];
      this.provinciasList = [];

      if (this.paisNombre)
      {
        let pais = this.getSelected(this.paises, this.paisNombre);
        if (pais)
        {
          this.$store.dispatch('provincias/getList', pais.id)
            .then(() => {
              this.provincias = this.$store.getters['provincias/list']
              this.provinciasList = this.$store.getters['provincias/selectList']
              this.loadingProvincias = false;
            })
            .then (() => this.getLocalidades())
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de provincias.'));
        }
      }
    },
    getLocalidades() {
      this.localidades = [];
      this.localidadesList = [];

      if (this.provinciaNombre)
      {
        var provincia = this.getSelected(this.provincias, this.provinciaNombre);
        if (provincia)
        {
          this.$store.dispatch('localidades/getLocalidadesProvincia', provincia.id)
            .then(() => {
              this.localidades = this.$store.getters['localidades/localidadesProvincia'];
              this.localidadesList = this.$store.getters['localidades/localidadesProvinciaList'];
            })
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de localidades'));
        }
      }
    },

    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "nombre" || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del contacto';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

      if (campo == 'documentoNumero' || validarTodos) {
        if (this.$v.documentoNumero.$error) {
          this.documentoNumeroValido = false;
          if (!this.$v.documentoNumero.required) {
            this.documentoNumeroInvalidoMsj = 'Debe ingresar el código de identificación del cliente';
          } else if (!this.$v.documentoNumero.DocumentoValido) {
            this.documentoNumeroInvalidoMsj = 'Verifique por favor el código de identificación ingresado';
          } else if (!this.$v.documentoNumero.maxLength) {
            this.documentoNumeroInvalidoMsj = 'El código de identificación solo puede contener hasta 20 caracteres';
          }      
        } else {
          this.documentoNumeroValido = null;
          this.documentoNumeroInvalidoMsj = '';
        }
      }

      // if (campo == 'documentoNumero' || validarTodos) {
      //   if (this.$v.documentoNumero.$error) {
      //     this.documentoNumeroValido = false;
      //     /* if (!this.$v.documentoNumero.required) {
      //       this.documentoNumeroInvalidoMsj = 'Debe ingresar el número de documento';
      //     } else */ if (!this.$v.documentoNumero.numeric) {
      //       this.documentoNumeroInvalidoMsj = 'El número de documento solo puede contener números';
      //     }      
      //   } else {
      //     this.documentoNumeroValido = null;
      //     this.documentoNumeroInvalidoMsj = '';
      //   }
      // }

      if (campo == "direccion" || validarTodos) {
        if (this.$v.direccion.$error) {
          this.direccionValida = false;
          if (!this.$v.direccion.required) {
            this.direccionInvalidaMsj = 'Debe ingresar la dirección del contacto';
          } else if (!this.$v.direccion.maxLength) {
            this.direccionInvalidaMsj = 'La dirección sólo puede contener hasta 150 caracteres';
          }
        } else {
          this.direccionValida = null;
          this.direccionInvalidaMsj = '';
        }
      }

      if (campo == 'codigoPostal' || validarTodos) {
        if (this.$v.codigoPostal.$error) {
          this.codigoPostalValido = false;
          if (!this.$v.codigoPostal.required) {
            this.codigoPostalInvalidoMsj = 'Debe ingresar el código postal del contacto';
          } else if (!this.$v.codigoPostal.maxLength) {
            this.codigoPostalInvalidoMsj = 'El código postal solo puede contener hasta 8 caracteres';
          }      
        } else {
          this.codigoPostalValido = null;
          this.codigoPostalInvalidoMsj = '';
        }
      }

      if (campo == 'telefono' || validarTodos) {
        if (this.$v.telefono.$error) {
          this.telefonoValido = false;
          if (!this.$v.telefono.maxLength) {
            this.telefonoInvalidoMsj = 'El número de teléfono solo puede contener hasta 150 caracteres';
          }      
        } else {
          this.telefonoValido = null;
          this.telefonoInvalidoMsj = '';
        }
      }
         
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      let save = Boolean(true);

      let documentoTipo = null;
      if (this.documentoTipoNombre) {
        documentoTipo = this.getSelected(this.documentosTipos, this.documentoTipoNombre);
      }
      this.$store.dispatch('remitodestino/setDocumentoTipo', documentoTipo);

      let documentoTipoError = true;
      if (this.documentoTipo) {
        if (this.documentoTipo.id) {
          if (this.documentoTipo.id != 0) {
            documentoTipoError = false;
          }
        }
      }
      if (documentoTipoError) {
        save = Boolean(false);
        this.documentoTipoValido = false;
        this.documentoTipoInvalidoMsj = "Debe seleccionar el tipo de identificación.";
      }

      let pais = null;
      if (this.paisNombre) {
        pais = this.getSelected(this.paises, this.paisNombre);
      }
      this.$store.dispatch('remitodestino/setPais', pais);

      let paisError = true;
      if (this.pais) {
        if (this.pais.id) {
          if (this.pais.id != 0) {
            paisError = false;
          }
        }
      }
      if (paisError) {
        save = Boolean(false);
        this.paisValido = false;
        this.paisInvalidoMsj = "Debe seleccionar el pais correspondiente.";
      }

      let provincia = null;
      if (this.provinciaNombre) {
        provincia = this.getSelected(this.provincias, this.provinciaNombre);
      }
      this.$store.dispatch('remitodestino/setProvincia', provincia);

      let provinciaError = true;
      if (this.provincia) {
        if (this.provincia.id) {
          if (this.provincia.id != 0) {
            provinciaError = false;
          }
        }
      }
      if (provinciaError) {
        save = Boolean(false);
        this.provinciaValida = false;
        this.provinciaInvalidaMsj = "Debe seleccionar la provincia correspondiente.";
      }

      let localidad = null;
      if (this.localidadNombre) {
        localidad = this.getSelected(this.localidades, this.localidadNombre);
      }
      this.$store.dispatch('remitodestino/setLocalidad', localidad);

      let localidadError = true;
      if (this.localidad) {
        if (this.localidad.id) {
          if (this.localidad.id != 0) {
            localidadError = false;
          }
        }
      }
      if (localidadError) {
        save = Boolean(false);
        this.localidadValida = false;
        this.localidadInvalidaMsj = "Debe seleccionar la localidad correspondiente.";
      }

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('remitodestino/save')
            .then(() => {
              if (!this.modal) {
                this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light')
              } else {
                this.$emit('updateRemitoDestino', 
                  this.$store.getters['remitodestino/remitoDestino']);
              }
            })
            .catch( error => {
              if (!this.modal) {
                this.showErrorMsj(error);
              } else {
                this.alertMsj = error;
                this.alertVariant = "danger";
                this.alertCountDown = 15;
                this.showAlert();              
              }
            })
            .finally(() => {
              this.hideSpinner();
            })
        }
      }
    },
    goBack() {
      if (!this.modal) {
        this.$router.push({ name: 'RemitosDestinos' });
      } else {
        this.$emit('closeRemitoDestino');
      }
    },
    goList() {
      this.modalRegistroExitoso = false
      this.$router.push({ name: 'RemitosDestinos' });
    },
    paisActualizado(paisNombre) {
      if (!this.loadingPaises) {
        this.paisNombre = paisNombre;
        this.provinciaNombre = null;
        this.localidadNombre = null;
        this.getProvincias();
        this.getLocalidades();
        
        this.paisValido = null;
        this.paisInvalidoMsj = '';
      }
    },
    provinciaActualizada(provinciaNombre) {
      if (!this.loadingProvincias) {
        this.provinciaNombre = provinciaNombre;
        this.localidadNombre = null;
        this.getLocalidades();

        this.provinciaValida = null;
        this.provinciaInvalidaMsj = '';
      }
    },
    localidadActualizada(localidadNombre) {
      this.localidadNombre = localidadNombre;
      if (this.localidadNombre) {
        this.localidadValida = null;
        this.localidadInvalidaMsj = '';
      }
    },
    addLocalidad() {
      let addLocalidad = false;
      let provincia = null;

      if (this.provinciaNombre) {
        provincia = this.getSelected(this.provincias, this.provinciaNombre);
        this.$store.dispatch('remitodestino/setProvincia', provincia);

        if (this.provincia) {
          if (this.provincia.id != 0) {
            addLocalidad = true;
          }
        }
      }

      if (addLocalidad) {
        this.$refs.localidadModal.show();
      } else {
        this.showModalMsj('Seleccione en primer término la provincia correspondiente', null, null, 'light')
      }      
    },
    updateLocalidades(localidadNombre) {
      this.$refs.localidadModal.hide()
      this.getLocalidades();
      this.localidadNombre = localidadNombre.trim();
    },
    closeLocalidad() {
      this.$refs.localidadModal.hide()
    },
    documentoTipoActualizado(documentoTipoNombre) {
      this.documentoTipoNombre = documentoTipoNombre;
      if (this.documentoTipoNombre) {
        this.documentoTipoValido = null;
        this.documentoTipoInvalidoMsj = '';
      }
    },
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
    documentoNumero: {
      // required: requiredIf(function () {
      //   var isRequired = true;

      //   if (this.condicionFiscalNombre) {
      //     var condicionFiscal = this.getSelected(this.condicionesFiscales, this.condicionFiscalNombre);
      //     if (condicionFiscal) {
      //       if (condicionFiscal.id == 3) {
      //         isRequired = false;
      //       }
      //     }
      //   }
      //   return isRequired;
      // }),
      DocumentoValido,
      maxLength: maxLength(20)
      // numeric,
    },
    direccion: {
      required,
      maxLength: maxLength(150)
    },
    codigoPostal: {
      required: requiredIf(function () {
        if (this.pais) {
          if (this.pais.id) {
            if (this.pais.id == 1) {
              return true;
            }
          }
        }
        return false;
      }),      
      // required,
      maxLength: maxLength(8)
    },
    telefono: {
      maxLength: maxLength(150)
    },
  },  
}
</script>

<style>
</style>
